import { createActions, createReducer } from 'reduxsauce';
import { IRequestConfig } from '../../models/Axios';

interface CurrentTabType {
  currentNameTab?: string;
  currentTabPage: number;
}

type TabPagePayload = number | { currentNameTab: string; currentTabPage: number };

export const { Types, Creators } = createActions({
  setCurrentTab: [],
  setCurrentTabPage: [],
});

const INITIAL_STATE: CurrentTabType = {
  currentNameTab: "",
  currentTabPage: 0
};

const setCurrentTab = (state = INITIAL_STATE, action: IRequestConfig<Array<string>>) => ({
  ...state,
  currentNameTab: action.data
});

const setCurrentTabPage = (state = INITIAL_STATE, action: IRequestConfig<TabPagePayload>) => {
  if (action.data !== null && typeof action.data === 'object') {
    return {
      ...state,
      currentNameTab: action.data.currentNameTab,
      currentTabPage: action.data.currentTabPage,
    };
  }
  return {
    ...state,
    currentTabPage: action.data as number,
  };
};

export default createReducer(INITIAL_STATE, {
  [Types.SET_CURRENT_TAB as any]: setCurrentTab,
  [Types.SET_CURRENT_TAB_PAGE as any]: setCurrentTabPage,
});
